/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const BATCH_LOGO = require("./res/images/paper.png");
export const DATE_LOGO = require("./res/images/calendar-2.png");
export const CHOOSE_GIF_URI = require("./res/gif/choose.gif");
export const RP_BANNER = require("./res/images/RP_Banner.png");
export const SUCCESS = require("./res/images/right.png");
export const FAILURE = require("./res/images/wrong.png");

export const IMAGES = [VLINDER_LOGO, BATCH_LOGO, DATE_LOGO, CHOOSE_GIF_URI, RP_BANNER, SUCCESS, FAILURE];
